<template lang="pug">
#modal-vincular-laudos-em-lote
    el-dialog(
        width='80%',
        title='Selecione as empresas e laudos',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        main
            .modal-vincular-laudos-em-lote__laudos
                h3.mb-3
                    | Laudos

                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaLaudos',
                        :data='laudosFiltrados',
                        size='mini',
                        height='350px',
                        @selection-change='alterarLaudosSelecionados'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='nome',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroLaudos',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ laudosSelecionados.length }} {{ laudosSelecionados.length === 1 ? 'laudo selecionado' : 'laudos selecionados' }}

            .modal-vincular-laudos-em-lote__empresas
                h3.mb-3 Empresas
                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaEmpresas',
                        :data='empresasFiltradas',
                        size='mini',
                        height='350px',
                        @selection-change='alterarEmpresasSelecionadas'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='name',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroEmpresas',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ empresasSelecionadas.length }} {{ empresasSelecionadas.length === 1 ? 'empresa selecionada' : 'empresas selecionadas' }}

        footer(slot='footer')
            BaseButton(size='mini', @click='fechar') Cancelar
            BaseButton(size='mini', type='primary', @click='executarAcao') {{ acao === 'VINCULAR' ? 'Vincular' : 'Remover' }}
</template>

<script>
import LaudoEmpresaService from '@/services/LaudoEmpresaService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalVincularLaudosEmLote',

    components: {
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        empresas: {
            type: Array,
            required: true
        },
        laudos: {
            type: Array,
            required: true
        },
        acao: {
            type: String, // VINCULAR | REMOVER
            required: true
        }
    },

    data() {
        return {
            filtroEmpresas: '',
            filtroLaudos: '',
            empresasSelecionadas: [],
            laudosSelecionados: []
        };
    },

    computed: {
        empresasFiltradas() {
            return this.empresas.filter(empresa =>
                empresa.name
                    .toLowerCase()
                    .includes(this.filtroEmpresas.toLowerCase())
            );
        },

        laudosFiltrados() {
            return this.laudos.filter(camada =>
                camada.nome
                    .toLowerCase()
                    .includes(this.filtroLaudos.toLowerCase())
            );
        }
    },

    methods: {
        fechar() {
            this.filtroEmpresas = '';
            this.filtroLaudos = '';
            this.empresasSelecionadas = [];
            this.laudosSelecionados = [];

            this.$refs.tabelaEmpresas.clearSelection();
            this.$refs.tabelaLaudos.clearSelection();

            this.$emit('fechar');
        },

        alterarEmpresasSelecionadas(linhas) {
            this.empresasSelecionadas = linhas;
        },

        alterarLaudosSelecionados(linhas) {
            this.laudosSelecionados = linhas;
        },

        executarAcao() {
            if (this.acao === 'VINCULAR') this.vincularLaudos();
            else this.removerLaudos();
        },

        async vincularLaudos() {
            const idsEmpresas = this.empresasSelecionadas.map(({ id }) => id);
            const idsLaudos = this.laudosSelecionados.map(({ id }) => id);

            try {
                await LaudoEmpresaService.vincularLaudosEmpresas(
                    idsEmpresas,
                    idsLaudos
                );

                this.$emit('atualizar-tabela');
                this.$notify.success({ message: 'Laudos vinculados' });
                this.fechar();
            } catch (e) {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao vincular os laudos as empresas'
                });
            }
        },

        async removerLaudos() {
            const idsEmpresas = this.empresasSelecionadas.map(({ id }) => id);
            const idsLaudos = this.laudosSelecionados.map(({ id }) => id);

            try {
                await LaudoEmpresaService.removerLaudosEmpresas(
                    idsEmpresas,
                    idsLaudos
                );

                this.$emit('atualizar-tabela');
                this.$notify.success({ message: 'Laudos desvinculados' });
                this.fechar();
            } catch (e) {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao remover vinculo de laudos com empresas'
                });
            }
        }
    }
};
</script>
<style lang="scss">
#modal-vincular-laudos-em-lote {
    main {
        display: flex;
        justify-content: center;
        gap: 16px;

        footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    .modal-vincular-laudos-em-lote__empresas,
    .modal-vincular-laudos-em-lote__laudos {
        width: 45%;

        h3 {
            display: flex;
            font-size: 16px;
            justify-content: space-between;
            align-items: center;
            height: 28px;
        }
    }
}
</style>
